function Breeding() {
  return (
    <div className="mt-4 Breeding">
      <section class="text-black body-font">
        <div class="container mx-auto flex px-5 py-8 items-center justify-center flex-col">
          <div class="text-center lg:w-2/3 w-full">
            <h1
              class="title-font sm:text-7xl text-4xl mb-4 font-medium  orange-text "
              style={{ fontFamily: "font1" }}
            >
              Breeding
            </h1>
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Mechanics
            </h1>
            <p class="mb-8 leading-relaxed text-left text-xs sm:text-xl">
              Every species can breed Baby ECOZ using the $THRIVE token, as long
              as you hold two parent genesis of the species you are trying to
              breed. Cost to breed are proportional to token yield for each
              species but also change in real time as specie’s populations
              increase/decrease to keep an equilibrium in the ecosystem. -"Breed
              Now" button goes to Breed page
            </p>
            <div class="flex justify-center  sm:mb-8 mb-4 -mt-8">
              <div>
                <img
                  src="https://res.cloudinary.com/dqzpz4w3l/image/upload/v1643569842/Breeding_z4ipqy.png"
                  alt="jaguar"
                  class="sm:h-40 h-10"
                />
              </div>
            </div>
            <div class="flex justify-center">
              <a
                href="/breed"
                class="orange border-white border-2 shadow-md text-white px-10 p-2 text-lg hover:scale-105 transition duration-500 ease-in-out transform hover:shadow-lg hover:text-orange"
              >
                Breed Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Breeding;
